<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row">
				<div class="col-md-12">
          <h3>{{ currpos.name }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="[{ id: 'general', label: _('General') }, { id: 'links', label: _('Links'), hidden: !isAccountingConfigured }]" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('General') }}</h3>
                <div class="form-group">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" class="form-control" id="cashregisterName" v-model="currpos.name" :placeholder="_('Enter cash register name')" />
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('links')" class="tab-pane active" id="links" v-if="isTabActive('links') && isAccountingConfigured" key="links">
            <div class="row">
              <div class="col-lg-6 leftcol">
                <div class="form-group">
                  <h3>{{ _('Cost objects') }}</h3>
                  <draggable-multi-selector v-model="currpos.sharedDimension" :items="allDimensions" :groups="true" :single-select="isBrioxAccountingMode" itemProperty="name" :selectorTitle="_('Link a Cost object')" />
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <button class="btn btn-danger" type="button" v-on:click="remove" v-if="currpos.id && currpos.id !== pos"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete') }}</span></button>
        <div class="button-col">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import dimensions from '~/lib/dimensions'
import settingshelpers from '~/lib/settingshelpers'
import { DraggableMultiSelector } from '#components'

export default {
  data () {
    return {
      currpos: {},
      saving: false,
    }
  },
  mixins: [components, dimensions, settingshelpers],
  methods: {
    async doRemove () {
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/pos/' + this.currpos.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return this.showError(e)
      }
      this.close()
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'sharedDimension'
      ]
      return exportFields.reduce((a, e) => (a[e] = this.currpos[e], a), {})
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/pos/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/pos.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadPos(response.data.id)
      }
      this.saving = false
      this.saved = true
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadPos (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/pos/' + id + '.json?dimensions=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.currpos = response.data
        this.storeState()
        this.loading = false
        resolve(this.currpos)
      })
    }
  },
  components: {
    DraggableMultiSelector,
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadPos(this.component.initData.posId)
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.currpos && this.currpos.id && parseInt(this.currpos.id, 10) !== parseInt(this.component.initData.posId, 10)) {
        try {
          await this.loadPos(this.component.initData.posId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['posUpdate'] = async (message) => {
        if (message && message.data && this.currpos && parseInt(message.data.id, 10) === parseInt(this.currpos.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadPos(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
